module.exports = __webpack_public_path__ + "img/vertical_7_7_5010.e627a294.png";